import {handleLogout} from "components/utils"; import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Button, Col, Form, Row} from "react-bootstrap";
import axios from "axios";
import 'react-vertical-timeline-component/style.min.css';
import {randomString} from "../../../utils";

export const AddBedView = (props: { cookieEntityQr: string, caseId: string, bedName: string, postAction: any }) => {


    const [successMessage, setSuccessMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [bedId, setBedId] = useState<string>();
    const [availableBeds, setAvailableBeds] = useState<Array<any>>();
    const [assignedBed, setAssignedBed] = useState<string>();


    function fetchBeds() {
        axios.get('/api/backend/inventory/item/fetch/all/' + props.cookieEntityQr + "?type=SERVICE&category=Beds&excludeZero=true")
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setAvailableBeds(resp.data)
                if (resp.data && resp.data.length > 0) setBedId(resp.data[0].id)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }


    useEffect(() => {

        if (props.cookieEntityQr) {
            fetchBeds();
        }

    }, [props.cookieEntityQr])

    useEffect(() => {

        if (props.bedName) {
            setAssignedBed(props.bedName)
        }

    }, [props.bedName])


    const handleAddBed = (e) => {
        e.preventDefault();
        axios.post('/api/backend/ipd/case/audit/create/', {
            entityQr: props.cookieEntityQr,
            caseId: props.caseId,
            bedId: bedId,
            itemId: bedId,
            type: "BED"
        }).then(resp => {
            console.log(resp.data)
            props.postAction()
        })
            .catch(err => {
                setErrorMessage("Error while creating the audit trail")
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
            }).finally(() => setLoading(false));
    }

    const handleUnassignBed = (e) => {
        e.preventDefault();
        axios.post('/api/backend/ipd/case/audit/create/', {
            entityQr: props.cookieEntityQr,
            caseId: props.caseId,
            bedId: 0,
            itemId: 0,
            type: "BED"
        }).then(resp => {
            console.log(resp.data)
            props.postAction()
        })
            .catch(err => {
                setErrorMessage("Error while creating the audit trail")
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
            }).finally(() => setLoading(false));
    }

    function getAddNewWidget() {
        return <>
            <div className="mt-3"/>
            <div className="">
                <Form>
                    <div className="row">
                        {assignedBed && <div className="col col-12">
                            <div className="d-flex gap-5 mb-5">
                                <div className="text-secondary fs-7">Assigned Bed: <span className="fs-5 text-primary">{assignedBed}</span>
                                </div>
                                <button className="btn btn-warning text-white btn-sm"
                                        onClick={e => handleUnassignBed(e)}>
                                    {loading &&
                                        <div className="text-center">
                                            <div className="spinner-border" role="status">
                                            </div>
                                        </div>
                                    }
                                    {!loading && <>Unsssign Bed</>}
                                </button>
                            </div>
                        </div>}
                        <div className="col col-12">
                            <div className="text-secondary">Select Bed:</div>
                            <select className="form-select my-2 form-select-sm"
                                    value={bedId}
                                    onChange={e => {
                                        setBedId(e.target.value)
                                    }}
                            >
                                {availableBeds && availableBeds.map((service) => {
                                    return <option value={service.id} key={service.name}>{service.name}</option>
                                })
                                }
                            </select>
                        </div>

                        <div className="my-3">
                            <button className="btn btn-info text-white btn-sm"
                                    onClick={e => handleAddBed(e)}>
                                {loading &&
                                    <div className="text-center">
                                        <div className="spinner-border" role="status">
                                        </div>
                                    </div>
                                }
                                {!loading && <>Assign New Bed</>}
                            </button>
                            {errorMessage &&
                                <div className="text-danger fs-6">*{errorMessage}</div>
                            }
                        </div>
                    </div>

                </Form>
            </div>
        </>;
    }

    return (
        <>
            {getAddNewWidget()}
        </>
    );
}